export default __webpack_public_path__ + "static/media/habano1.6ff60461.png";